import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';



const root = createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    
    <Provider store={store}>
      <App />
    </Provider>
  </React.Fragment>
);

reportWebVitals();

// 🚀 PWA : enregistrement du service worker en production uniquement
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('SW registration failed:', err);
    });
  });
}

